import { useContext } from 'react';
import { LocaleContext } from '@/components/ui-component/LocalesProviderClient';

export const useLocale = () => {
  const context = useContext(LocaleContext);
  if (!context) {
    throw new Error('useLocale must be used within LocalesProvider');
  }
  return context;
};
